import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TooltipListPipe } from '../../pipes/tooltip-list.pipe';
import { AccountRoutingModule } from './account-routing.module';
import { ManageUserListComponent } from './manage-user/manage-user-list/manage-user-list.component';
import { ManageUserEditComponent } from './manage-user/manage-user-edit/manage-user-edit.component';
import { ManageUserCreateComponent } from './manage-user/manage-user-create/manage-user-create.component';
import { SharedModule } from '../../shared.module';
import { AuditComponent } from './audit/audit.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ManageBillingListComponent } from './manage-billing/manage-billing-list/manage-billing-list.component';
import { AccountSearchComponent } from './account-search/account-search.component';
import { ManageCaseComponent } from './manage-case/manage-case.component';
import { ManageCaseEditComponent } from './manage-case/manage-case-edit/manage-case-edit.component';
import { CreateCaseDialogComponent } from './manage-case/create-case-dialog/create-case-dialog.component';
import { ManageCaseFieldsComponent } from './manage-case-fields/manage-case-fields.component';
import { ArchiveJobsComponent } from './archive-job/archive-jobs.component';
import { EditArchiveComponent } from './archive-job/edit-archive/edit-archive.component';
import { AddArchiveDialogComponent } from './archive-job/add-archive-dialog/add-archive-dialog.component';
import { DownloadArchiveDialogComponent } from "./archive-job/download-archive-dialog/download-archive-dialog.component";

@NgModule({
	declarations: [
		TooltipListPipe,
		ManageUserListComponent,
		ManageUserEditComponent,
		ManageUserCreateComponent,
		AuditComponent,
		ManageBillingListComponent,
		AccountSearchComponent,
		ManageCaseComponent,
		ManageCaseEditComponent,
		CreateCaseDialogComponent,
		ManageCaseFieldsComponent,
		ArchiveJobsComponent,
		EditArchiveComponent,
		AddArchiveDialogComponent,
		DownloadArchiveDialogComponent,
	],
imports: [
		CommonModule,
		ReactiveFormsModule,
		FormsModule,
		MatButtonModule,
		MatCardModule,
		MatFormFieldModule,
		MatInputModule,
		MatSelectModule,
		MatToolbarModule,
		MatIconModule,
		MatListModule,
		MatSidenavModule,
		MatSortModule,
		MatTooltipModule,
		MatDialogModule,
		MatCheckboxModule,
		AccountRoutingModule,
		SharedModule,
		MatMenuModule,
		MatTableModule,
		MatPaginatorModule,
		MatProgressSpinnerModule,
		ScrollingModule
	]
})
export class AccountModule {
}
